import type { UploadFormItemProps } from "./upload-form-item.type";

import { Form } from "antd";

const UploadFormItem = (props: UploadFormItemProps) => {
  return (
    <Form.Item
      {...props}
      // Normalize form item value to always be an array of `UploadFile`
      valuePropName="fileList"
      getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
    />
  );
};

export default UploadFormItem;
